import { render, staticRenderFns } from "./VideoSeriesVideoCard.vue?vue&type=template&id=0d1c6ae1&scoped=true&"
import script from "./VideoSeriesVideoCard.vue?vue&type=script&lang=js&"
export * from "./VideoSeriesVideoCard.vue?vue&type=script&lang=js&"
import style0 from "./VideoSeriesVideoCard.vue?vue&type=style&index=0&id=0d1c6ae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c6ae1",
  null
  
)

export default component.exports